import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Name",
  "Email",
  "Mobail No",
  "Amount",
  "Status",
  "Actions",
];

const FarmingConferenceTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/view-farming-conference/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.name || "N/A"}</td>
                <td>{item?.email || "N/A"}</td>
                <td>{item?.phone || "N/A"}</td>
                <td>₹{item?.amount || "N/A"}</td>
                <td>
                  <span
                    className={
                      item?.status === "success"
                        ? `status status-green border rounded-2 p-2 text-uppercase`
                        : "status status-red border rounded-2 p-2  text-uppercase"
                    }
                  >
                    {item?.status || "NA"}
                  </span>{" "}
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FarmingConferenceTable;
